import { render, staticRenderFns } from "./NewsPagination.vue?vue&type=template&id=37222d34&"
import script from "./NewsPagination.vue?vue&type=script&lang=js&"
export * from "./NewsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports